// included_usages > 1 = the voucher is a pack of N usages, usable several times by the same recipient
// => multi usage is forced, and the quantity selected by the user is a number of packs
export const getVoucherIncludedUsages = voucher => parseInt(voucher?.included_usages ?? 1);

export const isVoucherPack = voucher => getVoucherIncludedUsages(voucher) > 1;
